module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-417.8289174.woff2";